import { useState, useEffect } from "react";
import Modal from '../../../../core/components/core/Util/Modal/CustomModal';
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import config from '../../../config/config';
import { getUserSession } from "../../../../core/util/core/Session"

function ApprovePreSale({ show, onClose, saleId, approvalId }) {
    const session = getUserSession();
    
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const [loading, setLoading] = useState(false);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/approval-sales-requests/save`
    };

    // ---------- FORM CONFIG ----------
    const getForm = (values) => {
        const form = {
            afterSubmit: (form, values) => {
                onClose();
            },
            id: approvalId,
            hiddenValues: {
                gci_user_id: session.loggedUserInfo.gci_user_id,
                status: 'approved',
                gci_sale_id: saleId
            },
            fields: [
                {
                    name: 'observation',
                    type: 'textarea',
                    label: 'Observação',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
            ],
            labelSubmitButton: "Confirmar",
            showGoBackButton: false,
            ...paths,
        };

        form.values = values;
        return form;
    };

    // ---------- LOAD FORM ----------
    useEffect(() => {
        const load = async () => {
            if (!show) return;

            setLoading(true);

            const form = getForm({});

            setForm(form);

            setFormContent(
                <CustomForm form={form} />
            );

            setLoading(false);
        };

        load();
    }, [show, saleId]);

    return (
        <Modal
            show={show}
            handleShow={() => { }}
            handleClose={onClose}
            handleConfirm={() => { }}
            title="Aprovar Pré-Venda"
            content={loading ? "Carregando..." : formContent}
            showButtons={false}
            showHeader={true}
        />
    );
}

export default ApprovePreSale;